<div class="host-task-calendar">
  <div class="task-calendar-container">
    <div class="time-lines-container">
      <div class="time-line-item" *ngFor="let time of listOfTimeline">
        <div class="time">{{ time | dateformat: [null, "hm"] }}</div>
        <div class="line"></div>
      </div>
    </div>

    <div class="tasks-container">
      <div class="task-item" *ngFor="let task of listOfTask" [ngStyle]="task.style" (click)="clickTask(task.id)">
        <div
          class="task-item-inner"
          [class.selected]="task.id === selectedTask"
          [style.background-color]="bgColor[task.status || 0]"
        >
          <span class="type">{{ "task.word.type.type_" + (task.type || 0) | translate }}</span>
          <span class="cleaner">{{ task?.staff?.name }}</span>
          <span class="time">{{ task.start | dateformat: [null, "hm"] }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
